<emm-management-layout>
  <emm-nutrition-assignments-search layout-center-header class="nutrition-assignments-search">
  </emm-nutrition-assignments-search>
  @if (locationSetType$ | async) {
    <emm-nutrition-assignments-location-sets
      layout-center-content
    ></emm-nutrition-assignments-location-sets>
  }
  @if (!(locationSetType$ | async)) {
    <emm-nutrition-assignments-list
      layout-center-content
      class="nutrition-assignments-list"
    ></emm-nutrition-assignments-list>
  }
  @if (assignment$ | async) {
    <emm-nutrition-assignments-right-header
      layout-right-header
      class="nutrition-assignments-right-header"
    ></emm-nutrition-assignments-right-header>
  }
  @if (assignment$ | async) {
    <emm-nutrition-assignments-form
      layout-right-content
      (formStateChanged)="buttonsState = $event"
      [isSuperAdmin]="isSuperAdmin"
      [isAdmin]="isAdmin"
      [locationSet]="locationSet$ | async"
    ></emm-nutrition-assignments-form>
  }
  @if (assignment$ | async) {
    <emm-nutrition-assignments-right-footer
      [disabledCancelButton]="buttonsState.disableCancel"
      [disabledSaveButton]="buttonsState.disableSave"
      [showPublish]="showPublish$ | async"
      layout-right-footer
      (cancel)="handleCancel()"
      (submit)="handleSubmit()"
      (publish)="handlePublish()"
      class="emm-nutrition-assignments-right-footer"
    ></emm-nutrition-assignments-right-footer>
  }
</emm-management-layout>
